import { lazy } from 'react';
/** Открывает форму питомца */
export const PetFormPageAsync = lazy(() => import('./PetForm/PetFormPage'));